import { AnimatePresence, motion } from 'framer-motion';

export default function PillBadge({ item, onClick }) {
  // Handle both string and object items
  const displayText =
    typeof item === 'object' && item.label ? item.label : item;
  const itemValue = typeof item === 'object' && item.value ? item.value : item;

  return (
    <AnimatePresence>
      <motion.span
        initial={{ opacity: 0, y: -5 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -5 }}
        transition={{ bounce: 0, duration: 0.2 }}
        className="inline-flex items-center h-7 rounded-full bg-green-100 text-white px-3 text-xs font-bold leading-none"
      >
        {displayText}
        <button
          type="button"
          className="ml-2 flex h-4 w-4 flex-shrink-0 items-center justify-center rounded-full text-white/80 hover:text-white hover:bg-white/20 whitespace-nowrap"
          data-item={itemValue}
          onClick={onClick}
        >
          <span className="sr-only">Remove {displayText} option</span>
          <svg
            className="h-2 w-2 pointer-events-none"
            stroke="currentColor"
            fill="none"
            viewBox="0 0 8 8"
          >
            <path
              strokeLinecap="round"
              strokeWidth="1.5"
              d="M1 1l6 6m0-6L1 7"
            />
          </svg>
        </button>
      </motion.span>
    </AnimatePresence>
  );
}
